export default __webpack_public_path__ + "static/media/selena.3119396e.png";